import { DatabasesAPI, TableDataAPI, TablesAPI } from '@makyoapp/makyo-sdk'

export const StandardDBProvider = {
  getDB: (dbId: string) => {
    return DatabasesAPI.ReqGet(dbId)
  },
  listTables: (dbId: string) => {
    return TablesAPI.ReqList(dbId, '')
  },
  renameDB: (dbId: string, name: string) => {
    return DatabasesAPI.ReqRename(dbId, name)
  },
  deleteDB: async (dbId: string) => {
    await DatabasesAPI.ReqDelete(dbId)
  },
  getTableData: (tableID: string, lang: string, userSpecific: string) => {
    return TableDataAPI.ReqListWithInfiniteScroll(tableID, lang, userSpecific)
  },
}
